<template>
  <button class="mobile-dashboard-button" @click.prevent="onClicked">
    <div class="row">
      <div class="col-4">
          <i class="fas fa-warehouse-alt fa-5x"></i>
      </div>
      <div class="col-8 text-right">
          <h2 class="font-bold">{{title}}</h2>
      </div>
    </div>
  </button>
</template>

<style lang="scss" scoped>
.mobile-dashboard-button {
  position: relative;
  width: 100%;
  border-radius: 8px;
  padding: 15px 20px;
  margin-bottom: 20px;
  margin-top: 20px;
  border: none;

  cursor: pointer;
  color: #ffffff;
  background-color: #23c6c8;

  overflow: hidden;
  -webkit-transition-duration: 0.4s;
  transition-duration: 0.4s;
}
.mobile-dashboard-button:after {
  content: "";
  background: #ffffff40;
  display: block;
  position: absolute;
  padding-top: 300%;
  padding-left: 350%;
  margin-left: -20px!important;
  margin-top: -120%;
  opacity: 0;
  transition: all 0.8s
}

.mobile-dashboard-button:active:after {
  padding: 0;
  margin: 0;
  opacity: 1;
  transition: 0s
}
</style>

<script>
export default {
  name: 'MobileDashboardButton',
  props: {
    title: String,
    to: String
  },
  methods: {
    onClicked(evt) {
      this.$router.push(this.$props.to)
    }
  }
}
</script>